import { useContext, useCallback } from "react";
import { useQueryClient } from "@tanstack/react-query";
import CustomerReservationsClient from "../../clients/CustomerReservationsClient";
import { UserContext } from "../context/userContext";

export const pricingStackQueryOptions = (orderId, market, commonId) => ({
  queryKey: ["pricingStack", { orderId, commonId }],
  queryFn: () =>
    CustomerReservationsClient.getPricingStack(orderId, market, commonId, "en"),
  staleTime: 60 * 1000,
  cacheTime: 5 * 60 * 1000,
  retry: 2,
});

export function usePricingStack(orderId) {
  const { user } = useContext(UserContext);
  const { market, dealerId, salesCode, brand } = user || {};
  const userCommonId = user
    ? `${market}|${dealerId}|${salesCode}|${brand}`
    : null;
  const queryClient = useQueryClient();

  const getPricingStack = useCallback(
    () =>
      queryClient.ensureQueryData(
        pricingStackQueryOptions(orderId, market, userCommonId)
      ),
    [orderId, market, userCommonId, queryClient]
  );

  return getPricingStack;
}
